import { useNavigate, useParams } from "react-router-dom";
import { MTopBar, ComandaBar } from "@/components/mobile/MTopBar";
import { AddItems } from "@/components/mobile/AddItems";
import { useComanda, useMobileCatalog } from "@/hooks/useMobileData";
import { useMobile } from "@/context/MobileContext";

export function useCartActions(cid) {
  const { cartOf, setCart } = useMobile();
  const cart = cartOf(cid);
  const add = ({ product: p, options = [], qty = 1, notes = "", name, price }) => setCart(cid, (cs) => {
    const key = `${p.id}|${JSON.stringify(options)}|${notes}`;
    return cs.some((i) => i.key === key) ? cs.map((i) => (i.key === key ? { ...i, qty: i.qty + qty } : i))
      : [...cs, { key, product_id: p.id, name: name || p.name, price: price ?? p.price, qty, options, notes }];
  });
  // Tira 1 do produto: da linha mais recente dele no carrinho (como o "−" do carrinho); a linha some ao chegar a zero.
  const dec = (p) => setCart(cid, (cs) => {
    const idx = cs.map((i) => i.product_id).lastIndexOf(p.id);
    if (idx < 0) return cs;
    const i = cs[idx];
    return i.qty <= 1 ? cs.filter((_, k) => k !== idx) : cs.map((x, k) => (k === idx ? { ...x, qty: x.qty - 1 } : x));
  });
  return { cart, add, dec, setCart: (fn) => setCart(cid, fn), total: cart.reduce((s, i) => s + i.price * i.qty, 0), count: cart.reduce((s, i) => s + i.qty, 0) };
}

export default function MProducts() {
  const { id } = useParams();
  const { c, cid } = useComanda(id, 0);
  const { products, categories, ready } = useMobileCatalog();
  const { cart, add, dec, total, count } = useCartActions(cid);
  const nav = useNavigate();
  return (
    <>
      <MTopBar title="Adicionar itens" back={`/m/comanda/${id}`} />
      {c && <ComandaBar c={c} />}
      <AddItems products={products} categories={categories} ready={ready} cart={cart} add={add} dec={dec} total={total} count={count} onCart={() => nav(`/m/comanda/${id}/carrinho`)} />
    </>
  );
}
